var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2762 3.55549C12.2762 3.55554 12.2763 3.55544 12.2762 3.55549L4.58797 11.2519L3.74178 14.2598L6.7535 13.4156L14.4417 5.71822C14.5036 5.65635 14.5389 5.57197 14.5389 5.48449C14.5389 5.3971 14.5042 5.31328 14.4424 5.25143C14.4423 5.25136 14.4424 5.25149 14.4424 5.25143L12.7434 3.55555C12.6814 3.4937 12.5974 3.4589 12.5098 3.4589C12.4223 3.4589 12.3382 3.49374 12.2762 3.55549ZM11.3845 2.66463C11.683 2.36663 12.0877 2.19922 12.5098 2.19922C12.9318 2.19922 13.3365 2.36661 13.635 2.66457C13.635 2.66455 13.635 2.66459 13.635 2.66457L15.334 4.36046C15.6324 4.65855 15.8002 5.06299 15.8002 5.48449C15.8002 5.90599 15.6326 6.31024 15.3342 6.60833L7.52964 14.4222C7.45306 14.4988 7.35798 14.5545 7.25358 14.5838L3.00127 15.7758C2.78175 15.8373 2.54606 15.7757 2.38486 15.6147C2.22366 15.4536 2.16205 15.2182 2.22372 14.999L3.41821 10.753C3.44739 10.6493 3.50271 10.5548 3.57889 10.4786L11.3845 2.66463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.241ad2335c2533b07309d7c3e4c495a5.svg";
export { ForwardRef as ReactComponent };